import { postRequest, putRequest } from '../config/auth';
import { RESET_PASSWORD } from '../config/api-url';
import { RESET_PASSWORD_MAIL } from '../config/api-url';

export const resetPasswordAPI = (data) => putRequest(`${RESET_PASSWORD}`, data);
export const generateResetPasswordMailAPI = (data) => postRequest(`${RESET_PASSWORD_MAIL}`, data);
